function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("circle", {
  cx: 128.92,
  cy: 58.8086,
  r: 6,
  transform: "rotate(101.838 128.92 58.8086)",
  fill: "white"
}), React.createElement("circle", {
  cx: 305.959,
  cy: 491.324,
  r: 6,
  transform: "rotate(101.838 305.959 491.324)",
  fill: "white"
}), React.createElement("circle", {
  cx: 29.2594,
  cy: -1.92714,
  r: 3,
  transform: "rotate(101.838 29.2594 -1.92714)",
  fill: "white"
}), React.createElement("circle", {
  cx: 176.334,
  cy: 383.439,
  r: 3,
  transform: "rotate(101.838 176.334 383.439)",
  fill: "white"
}), React.createElement("circle", {
  cx: 306.182,
  cy: 105.157,
  r: 3,
  transform: "rotate(101.838 306.182 105.157)",
  fill: "white"
}), React.createElement("circle", {
  cx: 269.427,
  cy: 241.518,
  r: 5,
  transform: "rotate(101.838 269.427 241.518)",
  fill: "white"
}), React.createElement("circle", {
  cx: 85.1314,
  cy: 277.476,
  r: 4,
  transform: "rotate(101.838 85.1314 277.476)",
  fill: "white"
}), React.createElement("path", {
  d: "M-24.9636 412.769L-189.823 297.499L-53.0085 93.2201L29.4645 -2.90587L17.6838 -161.189L173.833 -111.602L306.284 104.668L268.654 240.334L305.675 490.243L176.231 383.928L-24.9636 412.769Z",
  stroke: "white"
}), React.createElement("path", {
  d: "M128.533 58.2167L29.362 -2.4165L173.73 -111.113L128.533 58.2167Z",
  stroke: "white"
}), React.createElement("path", {
  d: "M-30.1651 210.909L-53.1111 93.7095L129.022 58.3192L-30.1651 210.909Z",
  stroke: "white"
}), React.createElement("path", {
  d: "M-30.1651 210.909L-189.926 297.988L85.0288 277.966L-30.1651 210.909Z",
  stroke: "white"
}), React.createElement("path", {
  d: "M127.554 58.0116L269.143 240.436L175.355 383.234L127.554 58.0116Z",
  stroke: "white"
}), React.createElement("path", {
  d: "M-25.3504 412.177L84.642 277.374L175.355 383.234",
  stroke: "white"
}), React.createElement("path", {
  d: "M84.642 277.374L127.452 58.5009L305.692 105.055",
  stroke: "white"
}));

var SvgLeftTopBg = function SvgLeftTopBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 432 499",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLeftTopBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leftTopBg.214e4a13.svg";
export { ForwardRef as ReactComponent };